export const paths = {
  mockup: (mockupName: string, mockupId: number | string) => {
    const parsedMockupName = mockupName.replace(new RegExp(' ', 'g'), '-');
    return `/mockup/${parsedMockupName}/${mockupId.toString()}`;
  },
};
